/**
 * Created by eriksundqvist on 12/10/16.
 */
export default class CouponEntity {

  constructor (
    discountValue
  ) {
    this.discountValue = discountValue;
  }

}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/coupons/coupon-entity.js
 **/